import styled, { css } from 'styled-components';

export const Select = styled.select<{ $error?: boolean }>`
  width: 85px;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  color: ${({ theme }) => theme.neutral_500};
  cursor: pointer;

  &:focus {
    font-size: 12px;
  }

  ${({ $error, theme }) =>
    $error &&
    css`
      border-color: ${theme.danger_500};
    `}
`;
